import React, { useEffect, useState } from 'react';

import { userHasAdminAccess } from '~/components/Integrations/helpers/freshchatHelpers';

type WithAdminAccessProps = {
  user: any;
  company: any;
};

const withAdminAccess = <P extends WithAdminAccessProps>(
  WrappedComponent: React.ComponentType<P>
) => (props: P) => {
  const { user, company } = props;
  const [hasAdminAccess, setHasAdminAccess] = useState<boolean | null>(null);

  useEffect(() => {
    let mounted = true;

    const checkAccess = async () => {
      try {
        const allowed = await userHasAdminAccess(user?.roles, company?.id);
        if (mounted) {
          setHasAdminAccess(allowed);
        }
      } catch {
        if (mounted) {
          setHasAdminAccess(false);
        }
      }
    };

    checkAccess();

    return () => {
      mounted = false;
    };
  }, [user?.roles, company?.id]);

  if (!hasAdminAccess) return null;

  return <WrappedComponent {...props} />;
};

export default withAdminAccess;
